var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Store from "@ember-data/store";
import { action } from "@ember/object";
import Service, { service } from "@ember/service";
import { buildWaiter } from "@ember/test-waiters";
import Patient from "core/models/patient";
import SemeiaSessionService from "core/services/session";
import { getEnvironmentName } from "core/utils/runtime-environment";
import { sleep } from "core/utils/time";
import ControlTower from "wise-control-tower";
const waiter = buildWaiter("cable-waiter");
const journalEventsWithFileAttachments = ["consultation-report-written-journal-event", "paramedical-care-prescribed-journal-event", "bio-exam-prescribed-journal-event", "dmp-document-retrieved-journal-event", "medication-prescribed-journal-event", "generic-prescription-uploaded-journal-event", "apicrypt-message-received-journal-event", "file-uploaded-journal-event", "medical-event-journal-event", "bio-exam-results-received-journal-event", "medical-imaging-prescribed-journal-event"];
class ChannelCommandCableMessage {
  constructor(command, channel, patientId) {
    this.command = command;
    this.channel = channel;
    this.patientId = patientId;
  }
  serialize() {
    const identifier = JSON.stringify({
      channel: this.channel,
      patient_id: this.patientId
    });
    return JSON.stringify({
      command: this.command,
      identifier: identifier
    });
  }
}
class DataCableMessage {
  constructor(channel, id, type, store, session) {
    this.channel = channel;
    this.id = id;
    this.type = type;
    this.store = store;
    this.session = session;
  }
  async treatMessage() {
    if (this.channel == "ReloadChannel") {
      try {
        if (this.type == "patient") {
          await this.store.findRecord("patient", this.id, {
            reload: true,
            include: ["medics", "health-centre"].join(",")
          });
        } else {
          const isJeStillLoading = await this.waitForJesLoading();
          // If JEs have finally finishing loading
          if (!isJeStillLoading) {
            if (["notification-triggered-journal-event", "alert-triggered-journal-event"].includes(this.type) && this.session.medic) {
              await this.store.query(this.type, {
                reload: true,
                filter: Object.assign({
                  id: this.id
                }, this.session.medic ? {
                  for_current_medic: ""
                } : {}),
                include: ["creator", "triggering-journal-event.creator"].join(",")
              });
            } else if (["notification-processed-journal-event", "alert-processed-journal-event"].includes(this.type) && this.session.medic) {
              // Will be `notification-triggered-journal-event` for `notification-processed-journal-event` type
              // Will be `alert-triggered-journal-event` for `alert-processed-journal-event` type
              const relation = this.type.replace("processed", "triggered");
              await this.store.findRecord(this.type, this.id, {
                reload: true,
                include: ["creator", `${relation}.creator`].join(",")
              });
            } else {
              const include = ["creator"];
              if (journalEventsWithFileAttachments.includes(this.type)) {
                include.push("file-attachments");
              }
              await this.store.findRecord(this.type, this.id, {
                reload: true,
                include: include.join(",")
              });
            }
          }
        }
      } catch (e) {
        if (e.errors?.[0].status != "404") {
          throw e;
        }
      }
    }
  }

  /**
   * @return a boolean that tells if a JE is still loading after waiting
   */
  async waitForJesLoading() {
    // Get the current JEs in the store to check if one is currently loading
    const jeOfTypes = this.store.peekAll(this.type).slice();
    const isJeLoading = () => jeOfTypes.some(je => je.isNew);
    let maxTry = 10;

    // Wait for the JE to finish loading
    while (maxTry > 0 && isJeLoading()) {
      await sleep(500);
      maxTry--;
    }
    return isJeLoading();
  }
}
let CableService = (_class = class CableService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
    _defineProperty(this, "patientsIdSubscriptions", new Set());
    _defineProperty(this, "url", ["local", "development"].includes(getEnvironmentName()) ? "ws://localhost:3000/cable" : "wss://" + window.location.host + "/cable");
  }
  get token() {
    return this.session.access_token;
  }
  async openSocket() {
    return new Promise(resolve => {
      try {
        const socket = new WebSocket(`${this.url}?token=${this.token}`);
        socket.onopen = () => {
          socket.onmessage = this.messageHandler;
          this.socketRef = socket;
          resolve();
        };
        // we remove the event
        // because we don't know how to treat it
        socket.onerror = () => {
          resolve();
        };
      } catch (err) {
        ControlTower.captureException(err);
        resolve();
      }
    });
  }
  closeSocket() {
    this.socketRef?.close();
  }
  sendChannelCommandCableMessage(command, patientId) {
    if (this.socketRef?.readyState == WebSocket.OPEN) {
      const msg = new ChannelCommandCableMessage(command, "ReloadChannel", patientId);
      this.socketRef.send(msg.serialize());
    }
  }
  subscribeToReloadChannel(patient) {
    this.sendChannelCommandCableMessage("subscribe", patient.id);
  }
  unsubscribeToReloadChannel(patient) {
    // We only unsub for existing subs
    if (this.patientsIdSubscriptions.has(patient.id)) {
      this.sendChannelCommandCableMessage("unsubscribe", patient.id);
      this.patientsIdSubscriptions.delete(patient.id);
    }
  }
  async messageHandler(event) {
    const data = JSON.parse(event.data);
    if (!["ping", "welcome"].includes(data.type)) {
      const waiterToken = waiter.beginAsync();
      const identifier = JSON.parse(data?.identifier);
      const channel = identifier?.channel;
      const message = data?.message;
      // Back-end send us a sub confirmation with the patient ID
      if (data.type == "confirm_subscription") {
        const patientId = identifier?.patient_id;
        if (patientId) {
          // If present, we store it to save the current subs
          this.patientsIdSubscriptions.add(patientId);
        }
      } else if (channel && message) {
        const dataCableMessage = new DataCableMessage(channel, message.id, message.type, this.store, this.session);
        await dataCableMessage.treatMessage();
      }
      waiter.endAsync(waiterToken);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "messageHandler", [action], Object.getOwnPropertyDescriptor(_class.prototype, "messageHandler"), _class.prototype), _class);
export { CableService as default };